import { useTranslation } from 'react-i18next';

export default function preloadTranslations() {
  useTranslation('cards');
  useTranslation('common');
  useTranslation('microphone');
  useTranslation('notifications');
  useTranslation('performance');
  useTranslation('requests');
  useTranslation('session');
  useTranslation('settings');
  useTranslation();
  useTranslation('widgets');
  useTranslation('wysiwyg');
}
